import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { REGEX } from '@app/utils/constants/regex.constants';

const MAX_LENGTH = 256;

export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = typeof control.value === 'string' ? control.value : '';

    if (!value) {
      return null;
    }

    if (value.length > MAX_LENGTH) {
      return { invalidEmail: true };
    }

    if (!REGEX.email.test(value)) {
      return { invalidEmail: true };
    }

    return null;
  };
}
